import React from 'react';

import '../styles/css/animated-logo.css';

const AnimatedLogo = () => (<div className="animated-logo">
  <style type="text/javascript" dangerouslySetInnerHTML={{
    __html: `
      body{
        background: linear-gradient(90deg,#0072ff,#00c6ff);
      }
      `}}
  />
  <a href="/" className="shorby-logo-ph animated">S<span>HORBY</span></a>
</div>)


export default AnimatedLogo;


// WEBPACK FOOTER //
// ./src/components/AnimatedLogo.js